import "./OrderView.scss";

import React from "react";
//import { Link } from "react-router-dom";
//import request from "request"
import usesFeatures from "usesFeatures"
import { formatDateTime, formatDateTimeWithZone, eventTimestampWithZone } from "date_helpers"
import { startCase } from "lodash"

import Table from "Table"
import Header from "Header"
import Card from "Card"
import DisplayField from "DisplayField"
import RefundForm from "./RefundForm"
import ReceiptSender from "ReceiptSender"

class OrderView extends React.PureComponent {
  state = {}
  static defaultProps = {
    dataSource: "internal/orders",
    showFees: true,
  }
  componentDidMount() {
    const orderId = this.props.match.params.id
    this.props.fetchData(`${this.props.dataSource}/${orderId}`)
  }

  renderProduct = (product, i) => {
    const { order } = this.props

    return(
      <div key={product.id} className="columns is-mobile is-vcentered">
        <div className="column">
          <p className="is-size-5 has-text-weight-semibold">
            { product.name }
            { product.quantity > 1 ? ` x${product.quantity}` : "" }
          </p>
            { product.fulfilled != product.quantity && (order.status == "complete" || order.status == "cancelled") &&
              <p>
                Refunded { product.quantity - product.fulfilled }
              </p>
            }
          { product.modifiers.length > 0 && <p>
            <span className="mr-2 has-text-weight-bold">Extras:</span>
            { product.modifiers.map((m) => m.name).join(", ") }
          </p> }
          { !order.allInclusive && <p>${ product.price }</p> }
        </div>
      </div>
    )
  }

  render() {
    if (!this.props.dataFetched) return false

    const { order, events } = this.props
    const { customer } = order

    return(
      <div className="OrderView">
        <Header
          text="Order"
          backLink="/orders"
        />
        <div className="columns">
          <div className="column is-6">
            { customer &&
              <Card title="Customer">
                <DisplayField label="Name" value={customer.name} />
                <DisplayField label="Phone" value={customer.phone} />
                <DisplayField label="First Seen" value={formatDateTime(customer.createdAt)} />
              </Card>
            }
            <Card title="Order">
              <DisplayField label="Type" value={startCase(order.type)} />
              <DisplayField label="Payment Type" value={startCase(order.paymentType)} />
              {order.payment?.lastFour && (
                <DisplayField label="Card" value={`****${order.payment.lastFour}`} />
              )}
              <DisplayField label="Method" value={order.hasDelviery ? "Delivery" : "Pickup"} />
              <DisplayField label="Auto Progressed?" value={order.progressed ? "Yes" : "No"} />
              <DisplayField label="All Inclusive" value={order.allInclusive ? "Yes" : "No"} />
              <DisplayField label="Placed At" value={formatDateTimeWithZone(order.placedAt)} />
              <DisplayField label="Completed At" value={order.completedAt ? formatDateTimeWithZone(order.completedAt) : null} />
            </Card>
            <Card title="Order Details">
              { order.products.map(this.renderProduct) }

              { order.discountLineItems && order.discountLineItems.length > 0 &&
                <div className="mt-4">
                  <p className="has-text-weight-bold mb-2">Discounts Applied:</p>
                  { order.discountLineItems.map((dli, i) => (
                    <p key={i} className="ml-3">
                      <span>{dli.discount.name}</span>
                      <span className="ml-2">
                        {dli.quantity > 1 ? `(x${dli.quantity})` : ''}
                      </span>
                    </p>
                  ))}
                </div>
              }

              { order.gratuityLineItems && order.gratuityLineItems.length > 0 &&
                <div className="mt-4">
                  <p className="has-text-weight-bold mb-2">Gratuities Applied:</p>
                  { order.gratuityLineItems.map((gli, i) => (
                    <p key={i} className="ml-3">
                      <span className="has-text-weight-semibold">{gli.gratuity.name}</span>
                      <span className="ml-2">
                        {gli.gratuity.gratuityUnit === "percent"
                          ? `${gli.gratuity.gratuityAmount}%`
                          : `$${gli.gratuity.gratuityAmount}`}
                      </span>
                      <span className="ml-2 has-text-grey">{gli.gratuity.gratuityUnit}</span>
                      {gli.quantity > 1 &&
                        <span className="ml-2">(x{gli.quantity})</span>
                      }
                      <span className="ml-2">Applied: <span className="has-text-weight-semibold">{gli.appliedAmount}</span></span>
                    </p>
                  ))}
                </div>
              }

              { order.prepaidCreditLineItems && order.prepaidCreditLineItems.length > 0 &&
                <div className="mt-4">
                  <p className="has-text-weight-bold mb-2">Prepaid Credits Applied:</p>
                  { order.prepaidCreditLineItems.map((pcli, i) => (
                    <p key={i} className="ml-3">
                      <span>{pcli.prepaidCredit.code}</span>
                      <span className="ml-2 has-text-weight-semibold">{pcli.appliedAmount}</span>
                    </p>
                  ))}
                </div>
              }

              <div className="mt-4">
                <p>
                  <span className="has-text-weight-bold">Items Subtotal</span>
                  <span className="ml-2">${ order.subtotal }</span>
                </p>
                { order.discountAmount && order.discountAmount !== "$0.00" &&
                  <p>
                    <span className="has-text-weight-bold">Discount</span>
                    <span className="ml-2">-{ order.discountAmount }</span>
                  </p>
                }
                <p>
                  <span className="has-text-weight-bold">Sales Tax</span>
                  <span className="ml-2">${ order.taxes }</span>
                </p>
                { order.gratuityAmount && order.gratuityAmount !== "$0.00" &&
                  <p>
                    <span className="has-text-weight-bold">Gratuity</span>
                    <span className="ml-2">{ order.gratuityAmount }</span>
                  </p>
                }
                { order.prepaidCreditAmount && order.prepaidCreditAmount !== "$0.00" &&
                  <p>
                    <span className="has-text-weight-bold">Prepaid Credits</span>
                    <span className="ml-2">-{ order.prepaidCreditAmount }</span>
                  </p>
                }
                { order.tip > 0 &&
                  <p>
                    <span className="has-text-weight-bold">Tip</span>
                    <span className="ml-2">${ order.tip.toFixed(2) }</span>
                  </p>
                }
                { this.props.showFees && order.customerFee != "$0.00" &&
                  <p>
                    <span className="has-text-weight-bold">Customer Fee</span>
                    <span className="ml-2">{ order.customerFee }</span>
                  </p>
                }
                <p>
                  <span className="has-text-weight-bold">Total</span>
                  <span className="ml-2">${ order.chargeTotal }</span>
                </p>
              </div>
            </Card>
          </div>
          <div className="column is-6">
            { order.status == "complete" &&
            <Card>
              <RefundForm
                order={order}
                dataSource={this.props.dataSource}
                onRefunded={() => this.props.fetchData(`${this.props.dataSource}/${order.id}`)}
              />
            </Card>}
            { order.status == "complete" &&
            <Card title="Send Receipt">
              <ReceiptSender
                orderId={order.id}
                apiEndpoint={`/${this.props.dataSource}/${order.id}/send_receipt`}
              />
            </Card>}
            <Card title="Event Timeline">
              <Table
                rows={events}
                headers={EVENT_HEADERS}
                formatters={{
                  timestamp: (e) => eventTimestampWithZone(e.timestamp)
                }}
              />
            </Card>
          </div>
        </div>
      </div>
    )
  }
}

const EVENT_HEADERS = {
  prettyType: "Event Type",
  timestamp: "Time",
}

const EVENT_FORMATTERS = {
  timestamp: (e) => eventTimestamp(e.timestamp)
}

export default usesFeatures(["data"], OrderView)
